import { flare } from "@flareapp/js";
import { flareVue } from "@flareapp/vue";
import { redactFlareReport } from "~/lib/flareReport";

// eslint-disable-next-line no-restricted-exports
export default defineNuxtPlugin({
    name: "flare",
    setup(nuxtApp) {
        if (nuxtApp.$config.public.appEnv === "local") {
            return;
        }

        const { data: user } = storeToRefs(useUserStore());

        watchEffect(() => {
            flare.addContextGroup(
                "Merchant",
                user.value
                    ? {
                          name: user.value.app.display_name,
                      }
                    : {
                          name: "No Appname found",
                      },
            );

            // ids only: merchant users are customers, no e-mail or name
            flare.addContextGroup(
                "User",
                user.value
                    ? {
                          id: user.value.id,
                      }
                    : {
                          name: "Not logged in",
                      },
            );
        });

        flare.configure({ beforeSubmit: redactFlareReport });
        flare.light(nuxtApp.$config.public.flareAppKey);

        nuxtApp.vueApp.use(flareVue);

        nuxtApp.hook("vue:error", async (error, _instance, info) => {
            const flareReportError = error as Error;

            flare.addContextGroup("Info", {
                additional_Info: info,
                title: flareReportError.message,
            });
            await flare.report(flareReportError);
        });
    },
});
